import React                    from 'react';
import { connect }              from 'react-redux';
import { reducerType }          from 'reducer';
import EggBoxGrid               from './EggBoxGrid';
import closeModal               from 'functions/modal/closeModal';
import Draggable                 from 'react-draggable'
import { makeStyles }           from "makeStyles";
import {  
   // componentsStateType, 
    modalStateType 
}                               from 'reducer/types';

const useStyles = makeStyles()(
    (theme) => ({
    root : {
        position:        'fixed',
        left:            0,
        height:          '100vh',
        width:           '100vw',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        transition:      'opacity 0.5s',
        transform:       'all 0.4s',
        overflowY:       'scroll',
        overflowX:       'hidden',
        backgroundColor: 'rgba(0,0,0,0.3)',
        zIndex:           10,
        '&::-webkit-scrollbar': {
          width: '0.5em'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: `#FFF`,
          borderRadius:    10
        }
    },
    filter: {
        position: 'absolute',
        left:     0,
        height:   '100vh',
        width:    '100vw',
        zIndex:   0
    },
    modal: {
     //   marginLeft:      10,
        display:         'flex',
        //justifyContent:  'space-evenly',
        justifyContent:  'space-between',
        flexFlow:        'column',
        backgroundColor: '#FFF',
        border:          '1px solid #DDD',
        borderRadius:    '0.25em',
        boxShadow:       '2px 8px 10px rgba(0,0,0,0.2)',
        touchAction:     'manipulation',
    },
    title: {
        display:         'flex',
        width:           '80%',
        marginLeft:      '10%',
        marginTop:       15,
        justifyContent:  'center',
        flexFlow:        'column',
        fontSize:        20,
        lineHeight:      1.6,
        color:           '#334'
    },
   buttons: {
       width:          '100%',
       height:         60,
       display:        'flex',
       alignItems:     'center',
       justifyContent: 'center',
       color:          theme.darkBlue,
       fontSize:       18,
       borderTop:      '1px solid #DDD',
       cursor:         'pointer',
       '&:hover': {
         color: theme.blue,
       }
   }
}))


type ModalType = {
    size:       number[];
    question:   number;
    modalState: modalStateType;
}

const Modal: React.FC<ModalType> = ({ 
    size,
    question,
    modalState
}) => {

  const { classes } = useStyles();

  
  const [modalStyle] = React.useMemo(() => {


    const height = Math.min(400,size[1] - 50);
    const width = Math.min(630, size[0] - 30);

    return [
       {
          marginLeft: size[0]/2 - width/2,
          marginTop:  size[1]/2 - height/2,
          width:      width,
          height:     height,
       }
    ]
   },[size])
   
   const nodeRef = React.useRef(null);

  return (
        <Draggable nodeRef = { nodeRef }>
            <div 
                ref      = { nodeRef }
                className = { classes.modal }
                style     = { modalStyle }
            >
                <div className = { classes.title }>
                    {''}
                </div>
                <EggBoxGrid question = { question }/>
                <div 
                    className = { classes.buttons }
                    onClick   = { closeModal }
                >
                    סגירה
                </div>
            </div>
        </Draggable>
  );
}



const mapStateToProps = (reducer: reducerType) => {
    
    return { 
     modalState: reducer.modal
  }};
  
  export default connect(mapStateToProps)(Modal);







